import styled from 'styled-components';
import { NewCartIcon, HelpIcon, InfoIcon, ShareIcon, UserIcon, SaveIcon, SaveIconMobile } from '../../const/icons';
import { NewCartIconDark, HelpIconDark, InfoIconDark, ShareIconDark, UserIconDark, SaveIconDark, SaveIconMobileDark } from '../../const/icons';
import { device } from '../../const/device';

export const LinkIcon = styled.a<{ icon: string, active?: boolean, invert?: boolean, color?: string, size?: number, count?:string, themeColor?: string, checkSurface?: number }>`
  width: ${props => props.size ?? 24}px;
  height: ${props => props.size ?? 24}px;
  position: relative;
  outline: 0;
  padding: 0;
  top: ${props => props.checkSurface === 2 ? 2 : 0}px;
  left: ${props => props.checkSurface === 2 ? 5 : 0}px;
  display: inline-block;
  cursor:pointer;
  z-index:6;
  
  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: url("data:image/svg+xml,${props => props.icon}") no-repeat center;
    pointer-events: none;
  }
  
  *{
    white-space: nowrap;
  }

  &:after{
    content:"${props => props.count}";
    color: ${props => props.themeColor == "black"? '#ffffff':'#000000'};
    position: absolute;
    font-size: 10px;
    font-family: Nunito Sans,sans-serif;
    width: 24px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    
    @media(${device.tablet}){
      top: 0;
      left: 4px;
    }
  }
`;

export const LinkShareIcon = styled(LinkIcon).attrs(props => ({ icon: (props => props.themeColor == "black" ?  props => ShareIconDark(props.invert) :  props => ShareIcon(props.invert)) }))`
  &:hover:before {
    background: url("data:image/svg+xml,${props => props.themeColor == "black"? ShareIconDark(true) : ShareIcon(true)}") no-repeat center;
  }
`;
export const LinkInfoIcon = styled(LinkIcon).attrs(props => ({ icon: (props => props.themeColor == "black" ?  props => InfoIconDark(props.invert) :  props => InfoIcon(props.invert)) }))`
  &:hover:before {
    background: url("data:image/svg+xml,${props => props.themeColor == "black"? InfoIconDark(true) : InfoIcon(true)}") no-repeat center;
  }
`;
export const LinkUserIcon = styled(LinkIcon).attrs(props => ({ icon: (props => props.themeColor == "black" ?  props => UserIconDark(props.invert) :  props => UserIcon(props.invert)) }))``;
export const LinkCartIcon = styled(LinkIcon).attrs(props => ({ icon: (props => props.themeColor == "black" ?  props => NewCartIconDark(props.invert) :  props => NewCartIcon(props.invert)) }))``;
export const LinkSaveIcon = styled(LinkIcon).attrs(props => ({ icon: (props => props.themeColor == "black" ?  props => SaveIconDark(props.invert) :  props => SaveIcon(props.invert)) }))<{loading:string}>`
  pointer-events:  ${props => props.loading === "true" ? "none" : "auto"};
  opacity: ${props => props.loading === "true" ? 0.6 : 1};
`;

export const LinkSaveIconMobile = styled(LinkIcon).attrs(props => ({ icon: (props => props.themeColor == "black" ?  props => SaveIconMobileDark(props.invert) :  props => SaveIconMobile(props.invert)) }))<{loading:string}>`
  pointer-events:  ${props => props.loading === "true" ? "none" : "auto"};
  opacity: ${props => props.loading === "true" ? 0.6 : 1};
`;

export const LinkHelpIcon = styled(LinkIcon).attrs(props => ({ icon: (props => props.themeColor =="black" ? props => HelpIconDark(props.color) : props => HelpIcon(props.color)),size: 16 }))`
  &:before {
    background-image: url("data:image/svg+xml,${props => HelpIcon(props.active ? '#000000' : undefined)}");  
  }
  &:hover:before {
    background-image: url("data:image/svg+xml,${HelpIcon('#000000')}");
  }
`;
